import Modal from '@Components/Shared/Modals/Modal';
import SelectField from '@Components/Shared/Controls/SelectField';
import { sandhillsRequest } from '@Components/Utilities/SandhillsUtility';
import { useState } from 'react';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';
import translator from '@Components/Utilities/Translator';
import Button from '@mui/material/Button';

const UserTimeZoneModal = (props) => {
    const currentUser = useRecoilValue(atoms.currentUser);
    const [selectedZone, setSelectedZone] = useState(currentUser.UserTimeZone);
    const routes = useRecoilValue(atoms.routes);
    const [showSuccess, setShowSuccess] = useState(false);

    const onSubmit = (save) => {
        sandhillsRequest({
            url: routes.UpdateUserTimeZone,
            method: 'post',
            data: {
                timeZone: selectedZone
            }
        }).then((data) => {
            if (data) {
                setShowSuccess(true);
                setTimeout(() => {
                    window.location.reload();
                }, 1500);
            } 
        }).catch((error) => {

        });
    }
    const onChange = (e) => {
        setSelectedZone(e.target.value);
    }

    return (
        <Modal containerClassName='time-zone-modal' onEscapeKeyClose={props.onClose}>
            <Modal.Header onClose={props.onClose}>
                <h2>{translator.translate('sandhills.tradepubwebsite.mvc.timezonepreferences')}</h2>
            </Modal.Header>
            <Modal.Body>
                {showSuccess &&
                    <div className='success-message'>{translator.translate('sandhills.tradepubwebsite.mvc.yourinformationhasbeenupdatedsuccessfully')}</div>}
                <SelectField
                    name='TimeZones'
                    options={props.options}
                    label={translator.translate('sandhills.tradepubwebsite.mvc.whereverpossibledisplaythefollowingtimezone')}
                    class='form-el'
                    selectClass='select-dropdown'
                    required={true}
                    onFieldChanged={onChange}
                    value={selectedZone}
                />
                <div className='buttons'>
                    <Button className='template-branded-button' sx={{ width: '150px', marginRight: '10px' }} onClick={() => onSubmit(true)}>
                        {translator.translate('sandhills.tradepubwebsite.mvc.submit')}
                    </Button>
                    <Button className='cancel-btn' sx={{ width: '150px', marginLeft: '10px' }} onClick={props.onClose}>
                        {translator.translate('sandhills.cancel')}
                    </Button>
                    </div>
            </Modal.Body>
        </Modal>
    );
}

export default UserTimeZoneModal;